// utils/arQuickLook.js
// AR Quick Look (iOS/iPadOS Safari): открытие .usdz вместо WebXR

// Папка в public/, где лежат usdz-файлы
export const USDZ_BASE = "/models/usdz";
// Модель по умолчанию (если нет отдельного файла под выбранный цвет)
export const DEFAULT_USDZ = `${USDZ_BASE}/gate.usdz`;

// Safari на iOS/iPadOS поддерживает <a rel="ar">
export const isQuickLookSupported = () => {
  if (typeof document === "undefined") return false;
  const a = document.createElement("a");
  return !!a.relList?.supports?.("ar");
};

// Ищем usdz под выбранный цвет: /models/usdz/<имя_материала>.usdz
// Если такого файла нет — возвращаем модель по умолчанию
export async function resolveUsdzUrl(materialName) {
  if (!materialName) return DEFAULT_USDZ;

  const url = `${USDZ_BASE}/${encodeURIComponent(materialName)}.usdz`;
  try {
    const res = await fetch(url, { method: "HEAD" });
    const type = res.headers.get("content-type") || "";
    // dev-сервер на отсутствующий файл может отдать index.html с кодом 200
    if (res.ok && !type.includes("text/html")) return url;
  } catch {
    /* нет файла или сети — используем дефолт */
  }
  return DEFAULT_USDZ;
}

// Открывает модель в AR Quick Look.
// Вызывать синхронно в обработчике клика, без await перед этим.
export function openQuickLook(url, { allowScaling = false } = {}) {
  const a = document.createElement("a");
  a.rel = "ar";
  // allowsContentScaling=0 — запрет масштабирования щипком (реальный размер ворот)
  a.href = allowScaling ? url : `${url}#allowsContentScaling=0`;
  // Safari распознаёт ссылку как AR только если внутри есть <img>
  a.appendChild(document.createElement("img"));
  a.click();
}
